export const TABLE_TAXONOMY = [
	{
		field: 'full_name',
		t: 'name',
	},
	{
		field: 'id',
	},
	{
		field: 'email',
	},
	{
		field: 'phone_nr',
		t: 'phone',
	},
	{
		field: 'date_of_birth',
		t: 'birthday',
		rowStyle: 'date',
		format: 'date',
	},
]
